import React from 'react';
import {Link} from 'react-router-dom';
import NavBar from '../components/NavBar';
import Dog from '../images/profilepic2.PNG';
import Logo from '../images/Logo.PNG';
import SLThumbnail from '../images/SLThumbnail.PNG'
import DCThumbnail from '../images/DCThumbnail.PNG'
import WNThumbnail from '../images/WNThumbnail.PNG'
function HomePage() {
  return (
      <div>   
        <header>
          <NavBar/>
        </header>
        <main>
          <div className="homepage-row">
            <div className="intro-left">
              <img src={Dog}/>
            </div>
            <div className = "intro-right">
              <img src={Logo} className='center'/>
              
              <h3>I'm Ellis, a recent graduate of Boston University with a passion for problem solving. <br/>
              I studied math and computer science and focused on topology and geometry processing. <br/> 
              I am originally from Nashville, TN and enjoy music, cooking, and biking.</h3>
            </div>
            <hr/>
          </div>

          <div className="homepage-row">
            <div className= "project-item">
              <ul className="home-list">
                <li><Link to="/SpernersLemma">Sperner's Lemma</Link></li>
              </ul>
              <img src={SLThumbnail} className='center'/>
              <p className='desc'> An interactive UI to demonstrate the proof and applications of Sperner's Lemma, made in Unity</p>
            </div>
            <div className= "project-item">
              <ul className="home-list">
                <li><Link to="/DeRham">DeRham Cohomology</Link></li>
              </ul>
              <img src={DCThumbnail} className='center'/>
              <p className='desc'> An expository paper on the relationship between the homology and deRham cohomology groups of smooth manifolds, advised by Professor Takashi Kimura</p>
            </div>
            <div className= "project-item">
              <ul className="home-list">
                <li><a href="http://dx.doi.org/10.1111/cgf.15141" target="_blank" rel="noopener noreferrer">Winding Number</a></li>
              </ul>
              <img src={WNThumbnail} className='center'/>
              <p className='desc'> A paper on how the winding number can be used to segment sketches. </p>
            </div>
          </div>

        </main>

      </div>
  );
}

export default HomePage